<template>
  <div class="q-pa-lg" style="padding-bottom: 60px;">

    <div class="box">
      <el-form size="small" :inline="true">
        <el-form-item>
          <el-input style="width: 200px;" v-model="iccid" placeholder="请输入卡号" />
        </el-form-item>

        <el-form-item >
          <el-date-picker style="padding-left:3px" v-model="selectDatetimest" type="date" placeholder="请选择开始查询时间" @change="dataSearchSt" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-form-item >
          <el-date-picker style="padding-left:3px" v-model="selectDatetimeed" type="date" placeholder="请选择结束查询时间" @change="dataSearchEd" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="btns">
        <el-button @click="list(1)" type="primary" plain size="small" icon="el-icon-search">搜索</el-button>
        <el-button @click="download" type="primary" plain size="small" icon="el-icon-download">导出</el-button>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border
              style="width: 100%;margin-top: 1%;height: 70vh">
      <el-table-column prop="iccid" label="iccid" min-width="100%">
      </el-table-column>

      <el-table-column prop="cardType" label="卡所属通道" min-width="100%">
      </el-table-column>
      <!--<el-table-column prop="status" label="卡状态" min-width="100%">
        <template slot-scope="scope">
          <div v-if="scope.row.status===0">待激活</div>
          <div v-if="scope.row.status===1">正常</div>
          <div v-if="scope.row.status===2">停机</div>
        </template>
      </el-table-column>-->
      <el-table-column prop="totalFlow" label="SO使用流量/Mb" min-width="100%">
      </el-table-column>
      <el-table-column prop="trueFlow" label="真实使用流量/Mb" min-width="100%">
      </el-table-column>
      <el-table-column min-width="100%" prop="createTime" label="查询时间">
      </el-table-column>
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'dailyUsedList',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    _this.loadType()
  },

  data() {
    return {
      maxHeight: 500,
      tableData: [],
      iccid: '',
      selectDatetimest: '',
      selectDatetimeed: '',
      options:[],
      cardType:'',
      cardJs: require('../../../api/card')
    }
  },
  created() {
    // this.initData({});
  },
  methods: {

    dataSearchSt(data) {
      this.selectDatetimest=data
    },
    dataSearchEd(data) {
      this.selectDatetimeed=data
    },
    list(page) {
      let _this = this
      _this.$nprogress.start()
      if ( _this.$check.checkIsNull(_this.iccid)) {
        _this.$alert('请输入卡号')
        return false
      }
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.$check.checkIsNull(_this.selectDatetimest)||_this.$check.checkIsNull(_this.selectDatetimeed)) {
        _this.$alert('请选择起止时间！')
        return false
      }

      let data={
        current: page,
        size: _this.$refs.pagination.size,
        iccid: _this.iccid,
        startTime:_this.selectDatetimest,
        endTime:_this.selectDatetimeed,
        costType:'day'
      }
      _this.cardJs.getMonthUsedInfo(data)
          .then(response => {
            if (response.data.code === "0") {
              _this.tableData = response.data.data.rows
              _this.$refs.pagination.render(page, response.data.data.total)
            } else {
              _this.$alert(response.data.msg)
            }
          })
    },
    download() {
      let _this = this
      if ( _this.$check.checkIsNull(_this.iccid)) {
        _this.$alert('请输入卡号')
        return false
      }
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.$check.checkIsNull(_this.selectDatetimest)||_this.$check.checkIsNull(_this.selectDatetimeed)) {
        _this.$alert('请选择起止时间！')
        return false
      }

      let data={
        current: 1,
        size: _this.$refs.pagination.size,
        iccid: _this.iccid,
        startTime:_this.selectDatetimest,
        endTime:_this.selectDatetimeed,
        costType:'day'
      }
      _this
          .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.cardJs.uploadDayFlowList(data)
                .then(res => {
                  if(res.data.code==='0'){
                    _this.$alert(res.data.data)
                  }else{
                    _this.$alert(res.data.msg)
                  }
                })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消！'
            })
          })
    },


  }
}
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
}
.btns {
  margin-left: 10px;
}
._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
</style>
<style lang="less" scoped>
/deep/.el-table .el-table__cell {
  padding: 0px !important;
}
/deep/thead.has-gutter {
  height: 40px;
}
/* 设置滚动条宽度和高度 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px; /* 横向滚动条 */
  height: 10px; /* 纵向滚动条 必写 */
}
/* 设置滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}
::v-deep .el-table {
  height: 88%;
.el-table__body-wrapper {
  height: calc(100% - 48px) !important; // 表格高度减去表头的高度
overflow-y: auto;
}
}
</style>
